import axios from "axios";

export class CommonAPIService {
  constructor() {
    this.apiUrl = process.env.VUE_APP_API_URL;
    this.aiUrl = process.env.VUE_APP_AI_URL;
    this.llmUrl = process.env.VUE_APP_LLM_URL;
  }

  getAuthHeaders() {
    const token =
      sessionStorage.getItem("signUpToken") || localStorage.getItem("jwtToken");
    return token ? { Authorization: `${token}` } : {};
  }

  newFileCall(url, formData) {
    const fullUrl = this.apiUrl + url;
    return axios
      .post(fullUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          ...this.getAuthHeaders(),
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  login(login, router, store, errors) {
    return axios
      .post(`${this.apiUrl}/api/auth/login`, login)
      .then((response) => {
          console.log(response)
        localStorage.setItem("jwtToken" + "", response.data.token);
        sessionStorage.removeItem("signUpToken");
        store.setUser(response.data.user);
        store.setLoggedIn(true);
        const appScopes = [];
        for (const authGroup of response.data.user.authGroups) {
          for (const scope of authGroup.scopes) {
            appScopes.push(scope);
          }
        }
        store.setAppScopes(appScopes);
        
        // Set subscription type from user data
        if (response.data.user.subscriptionTypeId) {
          store.setSubscriptionType(response.data.user.subscriptionType.name);
        } else {
          // Default to free if not specified
          store.setSubscriptionType('free');
        }
        
        return response.data;
      })
      .catch((e) => {
        console.log(e)
          errors.push(e);
        if (e.status === 402){
          return e.response.data
        }
        return { success: false, msg: "Login Failure" };
      });
  }
  
  register (parameters ) {
    return axios
      .post(`${this.apiUrl}/api/auth/register`, parameters)
      .then((res) => {
        return { success: true, data: res.data }; // explicitly return success
      })
      .catch(error => {
        // Extract the actual JSON body from the response, if present
        const errorBody = error.response && error.response.data
          ? error.response.data
          : { message: error.message };

        console.log('Registration failed:', errorBody);

        return {
          success: false,
          msg: errorBody.message || 'Registration Error',
          errorBody
        };
      });
      
  }

  registerBasic(registrationData, router, store, errors) {
    return axios
      .post(`${this.apiUrl}/api/auth/register-basic`, registrationData)
      .then((response) => {
        localStorage.setItem("jwtToken" + "", response.data.token);
        sessionStorage.removeItem("signUpToken");
        store.setUser(response.data.user);
        store.setLoggedIn(true);
        const appScopes = [];
        for (const authGroup of response.data.user.authGroups) {
          for (const scope of authGroup.scopes) {
            appScopes.push(scope);
          }
        }
        store.setAppScopes(appScopes);
        
        // Set subscription type from user data
        if (response.data.user.subscriptionType) {
          store.setSubscriptionType(response.data.user.subscriptionType);
        } else {
          // Default to free if not specified
          store.setSubscriptionType('free');
        }
        
        return response.data;
      })
      .catch((e) => {
        console.log(e)
        errors.push(e);
        if (e.status === 402){
          return e.response.data
        }
        return { success: false, msg: "Registration Failure" };
      });
  }
  
  klarnaAddRenewal (parameters ) {
    return axios
      .post(`${this.apiUrl}/api/payments/add_renewal`, parameters)
      .then((res) => {
        return { success: true, data: res.data }; // explicitly return success
      })
      .catch(error => {
        // Extract the actual JSON body from the response, if present
        const errorBody = error.response && error.response.data
          ? error.response.data
          : { message: error.message };

        console.log('Add Renewal failed:', errorBody);

        return {
          success: false,
          msg: errorBody.message || 'Renewal Error',
          errorBody
        };
      });

  }

  generateOTP(parameters, router, store) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    const fullUrl = `${this.apiUrl}/api/auth/generate-otp`;
    return axios
      .get(fullUrl, parameters)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          store.logOut()
          router.push({
            name: "splash",
          });
        }
        throw error;
      });
  }

  verifyOTP(parameters, router, store) {
    axios.defaults.headers.common.Authorization =
      localStorage.getItem("jwtToken");
    const fullUrl = `${this.apiUrl}/api/auth/verify-otp`;
    return axios
      .post(fullUrl, parameters)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status === 401) {
          store.logOut()
          router.push({
            name: "splash",
          });
        }
        throw error;
      });
  }

  postCall(url, parameters, router, store) {
    const fullUrl = this.apiUrl + url;
    return axios
      .post(fullUrl, parameters, { headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          store.logOut()
          router.push({ name: "splash" });
        }
        throw error;
      });
  }

  fileCall(url, files, router, store) {
    const fullUrl = this.apiUrl + url;
    return axios
      .post(fullUrl, files, {
        headers: {
          "Content-Type": "multipart/form-data",
          ...this.getAuthHeaders(),
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          store.logOut()
          router.push({ name: "splash" });
        }
        throw error;
      });
  }

  deleteCall(url, parameters, router, store) {
    const fullUrl = this.apiUrl + url;
    return axios
      .delete(fullUrl, { data: parameters, headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          store.logOut()
          router.push({ name: "splash" });
        }
        throw error;
      });
  }

  putCall(url, parameters, router, store) {
    const fullUrl = this.apiUrl + url;
    return axios
      .put(fullUrl, parameters, { headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          store.logOut()
          router.push({ name: "splash" });
        }
        throw error;
      });
  }

  getCall(url, parameters, router, store) {
    const fullUrl = this.apiUrl + url;
    return axios
      .get(fullUrl, { params: parameters, headers: this.getAuthHeaders() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 401) {
          store.logOut()
          router.push({ name: "splash" });
        }
        throw error;
      });
  }
}

export default CommonAPIService;
